import * as React from 'react';
import {styled, mq} from '../../../utils';
import {FormikProps} from 'formik';
import {PillButton} from '../../../components/Button';
import TextField, {TextFieldProps} from '../../../components/TextField';
import FormField from '../../../components/FormField';
import Flex from '../../../components/Flex';

export interface FormValues {
  password: string;
  passwordConfirm: string;
}

interface ResetPasswordBaseFormProps extends FormikProps<FormValues> {
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

const SubmitButton = styled(PillButton)({
  [mq('laptopAndUp')]: {
    marginBottom: 100
  }
});

export default class BaseForm extends React.Component<ResetPasswordBaseFormProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, handleSubmit, loading} = this.props;

    const commonFieldProps: TextFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      large: true
    };

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="Password">
          <TextField type="password" id="password" value={values.password} {...commonFieldProps} />
          <ErrorMessage show={Boolean(errors.password && touched.password)}>{errors.password}</ErrorMessage>
        </FormField>
        <FormField label="Password Confirmation">
          <TextField type="password" id="passwordConfirm" value={values.passwordConfirm} {...commonFieldProps} />
          <ErrorMessage show={Boolean(errors.passwordConfirm && touched.passwordConfirm)}>
            {errors.passwordConfirm}
          </ErrorMessage>
        </FormField>
        <Flex center={true}>
          <SubmitButton type="submit" variant="primary" loading={loading} large={true}>
            Submit
          </SubmitButton>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordForm/private/BaseForm.tsx